import script from "./TravelRulesGuide.vue?vue&type=script&lang=ts&setup=true"
export * from "./TravelRulesGuide.vue?vue&type=script&lang=ts&setup=true"

import "./TravelRulesGuide.vue?vue&type=style&index=0&id=355d7825&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-355d7825"]])

export default __exports__